'use client';

import { Heart, X } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

interface CrisisBannerProps {
  onDismiss: () => void;
}

export function CrisisBanner({ onDismiss }: CrisisBannerProps) {
  const { t } = useLanguage();

  return (
    <div className="bg-primary/10 border border-primary/30 rounded-lg p-4 mb-4 flex items-start gap-3" data-testid="crisis-banner-root">
      <Heart className="text-primary shrink-0 mt-0.5" size={20} />
      <div className="flex-1">
        <p className="text-sm font-medium text-foreground">{t.crisis.title}</p>
        <div className="flex gap-3 mt-3">
          <a
            href="https://988lifeline.org"
            target="_blank"
            rel="noopener noreferrer"
            className="px-3 py-1.5 bg-primary text-white rounded text-sm font-medium hover:bg-primary/90 transition-colors"
            data-testid="crisis-banner-get-help-link"
          >
            {t.crisis.getHelp}
          </a>
          <a
            href="https://findahelpline.com"
            target="_blank"
            rel="noopener noreferrer"
            className="px-3 py-1.5 border border-primary text-primary rounded text-sm font-medium hover:bg-primary/10 transition-colors"
            data-testid="crisis-banner-find-resources-link"
          >
            {t.crisis.findResources}
          </a>
        </div>
      </div>
      <button onClick={onDismiss} className="text-foreground-muted hover:text-foreground" data-testid="crisis-banner-dismiss-btn">
        <X size={18} />
      </button>
    </div>
  );
}

